// In-memory personal hub snapshots (survive section switches; keyed by viewer + section).

import {
  PERSONAL_HUB_SECTION_BLUEPRINTS,
  PERSONAL_HUB_SECTION_FACTIONS_REPUTATIONS,
  PERSONAL_HUB_SECTION_DASHBOARD,
  PERSONAL_HUB_SECTION_HANGAR,
} from '../personalHubRailConfig';

const store = new Map();
const MAX_ENTRIES = 24;

export function personalHubSessionCacheKey(section, viewerKey, extra = '') {
  const suffix = extra ? `:${extra}` : '';
  return `${section}:${viewerKey}${suffix}`;
}

/** @param {string} key */
export function getPersonalHubSessionCache(key) {
  return store.get(key) ?? null;
}

/** @param {string} key */
export function getPersonalHubSessionBoot(key) {
  return getPersonalHubSessionCache(key);
}

/** @param {string} key @param {object} payload */
export function setPersonalHubSessionCache(key, payload) {
  if (!key) return;
  store.set(key, { ...payload, at: Date.now() });

  if (store.size > MAX_ENTRIES) {
    let oldestKey = null;
    let oldestAt = Infinity;
    for (const [k, v] of store.entries()) {
      if (v.at < oldestAt) {
        oldestAt = v.at;
        oldestKey = k;
      }
    }
    if (oldestKey) store.delete(oldestKey);
  }
}

/** @param {string} [key] */
export function clearPersonalHubSessionCache(key) {
  if (key) store.delete(key);
  else store.clear();
}

export {
  PERSONAL_HUB_SECTION_BLUEPRINTS,
  PERSONAL_HUB_SECTION_DASHBOARD,
  PERSONAL_HUB_SECTION_HANGAR,
  PERSONAL_HUB_SECTION_FACTIONS_REPUTATIONS,
};
